var map = {
	"./email-icon.svg": 5124,
	"./fwd-icon.svg": 8155,
	"./left-arrow-icon.svg": 6037,
	"./wechat-icon.svg": 2053,
	"./whatsapp-icon.svg": 4958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9563;